import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import useLenis from "@/hooks/useLenis";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ServiceLanding from "@/pages/ServiceLanding";
import { captureUtms } from "@/lib/utm";

// Capture UTMs from the very first page hit (before the app renders).
if (typeof window !== "undefined") {
    captureUtms();
}

function App() {
    useLenis();
    return (
        <div className="App">
            <div className="grain-overlay" />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/servicos/:slug" element={<ServiceLanding />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
